var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnRevertGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5D667F",
    fillRule: "nonzero",
    d: "M10 5.747v3.68c0 .35-.19.68-.49.86l-3.12 1.85c-.36.21-.82.09-1.03-.26-.21-.36-.1-.82.26-1.03l2.87-1.71v-3.4c.01-.4.35-.74.76-.74.41 0 .75.34.75.75zm-10 .75v-5.29c0-.45.54-.67.85-.35l1.78 1.78a9.01 9.01 0 0 1 7.21-2.6c4.19.38 7.64 3.75 8.1 7.94a9 9 0 0 1-17.87 2.14c-.07-.6.4-1.12 1-1.12.5 0 .92.37.98.86.43 3.49 3.44 6.19 7.05 6.14 3.71-.05 6.84-3.18 6.9-6.9.06-3.9-3.11-7.1-7-7.1-1.93 0-3.68.79-4.95 2.05l2.09 2.09c.32.32.1.86-.35.86H.5c-.28 0-.5-.22-.5-.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnRevertGrey);
export default __webpack_public_path__ + "static/media/btn-revert-grey.ac8fa1edf1da5e28f3eec04342f8427a.svg";
export { ForwardRef as ReactComponent };